export enum AnnouncementName {
  SAFER_INTERNET_DAY_2025 = 'SAFER_INTERNET_DAY_2025',
}
